import React from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import { Button } from 'antd'

function List(props) {
  const {list, fetch, fetching, onShow} = props

  const columns = [
    {
      Header: 'ID',
      accessor: '_key',
      Cell: ({value, original}) => (
        <a onClick={() => onShow(original, 'edit')}>{value}</a>
      ),
    },
    {Header: 'Start Date', accessor: 'start'},
    {Header: 'End Date', accessor: 'end'},
    {Header: 'Order', accessor: 'order.code'},
    {Header: 'Contract', accessor: 'contract.code'},
    {Header: 'Employee Code', accessor: 'employee.code', hideable:true, hideDefault: true},
    {Header: 'Employee', accessor: 'employee.fn'},
    {Header: 'Company', accessor: 'company.fn', hideable:true, hideDefault: true},
    {
      Header: 'Processed',
      accessor: 'processed',
      Cell: ({value}) => (value ? 'Processed' : 'Unprocessed'),
    },
    {Header: 'Status', accessor: 'status'},
  ]

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      CreateButton={() => (
        <Button type={'primary'} size="small" icon={'plus'} onClick={onShow}>
          Add Timesheet
        </Button>
      )}
      columns={columns}
      defaultSorted={[
        {
          id: '_key',
          desc: true,
        },
      ]}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
